import { gql } from '@apollo/client';

export const DELETE_ASSET_MUTATION = gql`
    mutation deleteAsset($assetID: UUID!) {
        result: deleteAsset(assetID: $assetID) {
            affectedRows
        }
    }
`;
